import { useExperiment } from '@shared-ui/experiment-context';
// ABC test if 0 false, if 1 or 2 true
export const usePropertyDetailsQueryCSRExperiment = (logIt = true) => {
  const {
    exposure
  } = useExperiment('PropertyDetailsQuery_CSR', logIt);
  return Boolean(exposure === null || exposure === void 0 ? void 0 : exposure.bucket);
};